export default {
  STATUS: [
    { KEY: 2, VALUE: 'ERRO' },
    { KEY: 1, VALUE: 'CONCLUÍDA' },
    { KEY: 0, VALUE: 'PENDENTE' },
  ],
  TYPES: [{ KEY: 0, VALUE: 'MARINGA', LABEL: 'Prefeitura de Maringá' }],
  STATUS_TO_CSV_SAP: [
    { KEY: 1, VALUE: 'AUTORIZADA' },
    { KEY: 0, VALUE: 'PENDENTE' },
  ],

};
